// extracted by mini-css-extract-plugin
module.exports = {"tabs":"formLine_tabs__3uH7H","eliminar":"formLine_eliminar__2MdXZ","config-list":"formLine_config-list__z_i_l","delete-config":"formLine_delete-config__3zvfU"};